export const MSG_REQUIRED = "Campo obrigatório";